export default {"src":"/_next/static/media/readySite1.9693704f.svg","height":192,"width":220,"blurWidth":0,"blurHeight":0};